module.exports = __webpack_public_path__ + "img/article_11_3.eb90684f.webp";